import { Injectable, Inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config/config.service';
import { createClient, AssetCollection, ContentfulClientApi } from 'contentful';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  contentfulClient: ContentfulClientApi;
  readonly CONTENT_CODE: string = '';
  readonly CONTENTFUL_ID = 'OM_Airtrade';

  constructor(@Inject(ConfigService) public _configService: ConfigService, @Inject(HttpClient) public _http: HttpClient) {
    this.contentfulClient = createClient({
      space: _configService.getProperty<string>('CONTENTFUL_SPACE'),
      accessToken: _configService.getProperty<string>('CONTENTFUL_TOKEN'),
      host: _configService.getProperty<string>('CONTENTFUL_URL'),
      insecure: false,
    });
    this.CONTENT_CODE = this._configService.getProperty<string>('CONTENT_CODE');
  }

  getBasicTranslation(lang: string): Observable<any> {
    return from(this.getBasicTranslationData(lang)).pipe(mergeMap((data) => this._http.get(data.items[0].fields.file.url)));
  }

  getBasicTranslationData(lang: string): Promise<AssetCollection> {
    const code = this.getContentCode();

    return this.contentfulClient.getAssets({
      locale: lang,
      select: 'fields',
      'fields.title': `ORDERMANAGER_BASE_TRANSLATION`,
    });
  }

  getContentCode(): string {
    return this.CONTENT_CODE ? `_${this.CONTENT_CODE}` : '';
  }
}
